exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._4XQd3REl0yB7CxVq5Skcj{\n    border-color: var(--accent-color);\n    border-right-color: transparent;\n    border-width: 2px;\n    width: 1.5rem;\n    height: 1.5rem;\n}\n", ""]);
// Exports
exports.locals = {
	"spinner": "_4XQd3REl0yB7CxVq5Skcj"
};